module.exports = __webpack_public_path__ + "img/reference28.ce3bb0b7.jpg";